// getNotificationListData.js
'use strict';
import { Collection, Map, List } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

export const SortField = {
  TIMESTAMP: 'timestamp',
};
export const SortOrder = {
  DESC: 'desc',
  ASC: 'asc',
};

const defaultList = new List();
const defaultMap = new Map();

/**
 * Select notification list data
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} listType - notification list type.
 * @param {string} dataKey - data key.
 * @param {string} sortField - sort field.
 * @param {string} sortOrder - sort order.
 * @return {any} The selected notification list data.
 */
const getNotificationListData = createCachedSelector(
  state => state.get('notifications'),
  (state, listType) => state.getIn(['lists', 'notification', 'me', listType]),
  (state, listType, dataKey) => dataKey,
  (state, listType, dataKey, sortField) => sortField,
  (state, listType, dataKey, sortField, sortOrder) => sortOrder,
  (
    notificationMap = defaultMap,
    listMap = defaultMap,
    dataKey,
    sortField = SortField.TIMESTAMP,
    sortOrder = SortOrder.ASC
  ) => {
    let result;
    if (['itemIds', 'lastItemId'].includes(dataKey)) {
      const itemIds = listMap.get('itemIds') || defaultList;
      const sortedNotificationIds = itemIds
        .map(id => notificationMap.get(id))
        .sort((a = defaultMap, b = defaultMap) => {
          const aValue = a.get(sortField);
          const bValue = b.get(sortField);
          return sortOrder === SortOrder.ASC
            ? aValue - bValue
            : bValue - aValue;
        })
        .map(notification => notification.get('id'));
      if ('itemIds' === dataKey) {
        result = sortedNotificationIds;
      } else if ('lastItemId' === dataKey) {
        result = sortedNotificationIds.last();
      }
    } else {
      result = listMap.get(dataKey);
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)(
  (
    state,
    listType,
    dataKey,
    sortField = SortField.TIMESTAMP,
    sortOrder = SortOrder.ASC
  ) => `${listType}:${dataKey}:${sortField}:${sortOrder}`
);

export default getNotificationListData;
